<template>
  <div class="el-table-wrapper">
    <!-- 固定表头 -->
    <el-table
      class="elTable"
      :height="height?height:'calc(100vh - 220px)'"
      :border="showBorder"
      :header-cell-style="headerCellStyle"
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      :columns="columns"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <template v-for="(item, index) in columns">
        <!-- 普通渲染 -->
        <el-table-column
          :key="index"
          v-if="!item.slots && !item.hidden"
          :fixed="item.fixed ? item.fixed : false"
          :type="item.type"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth"
        ></el-table-column>
        <el-table-column
          :key="index + '_slot'"
          v-if="item.slots && !item.hidden"
          :fixed="item.fixed ? item.fixed : false"
          :type="item.type"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth"
        >
          <!--  渲染插槽 -->
          <template slot-scope="scope">
            <slot :name="item.slots" :row="scope.row"></slot>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <el-pagination
      v-if="total > 0"
      style="margin: 20px 0 0;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="listQuery.pageNumber"
      :page-sizes="[10, 50, 100, 500, 1000]"
      :page-size="listQuery.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "SelectForm",
  props: {
    height: {
      type: String
    },
    columns: {
      type: Array
    },
    tableData: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    total: {
      type: Number
    },
    listQuery: {
      type: Object,
      default: () => {
        return {
          pageNumber: 1,
          pageSize: 10
        };
      }
    },
    headerBgColor: {
      type: String,
      default: ""
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showBorder() {
      return this.border;
    },
    headerCellStyle() {
      const style = {
        background: this.headerBgColor || "#f0f4f3", //f0f4f3 f2f3f5 f5f7fa
        color: "#606266"
      };
      return style;
    }
  },
  data() {
    return {};
  },
  methods: {
    /* 分页 */
    handleCurrentChange(e) {
      this.$emit("handleCurrentChange", e);
    },
    handleSizeChange(e) {
      this.$emit("handleSizeChange", e);
    },
    /* 表格多选变化 */
    handleSelectionChange(selection) {
      this.$emit("handleSelectionChange", selection);
    }
  }
};
</script>

<style scoped lang="less">
.selectForm {
  // border: 1px solid red;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;

  // justify-content: center;
  .elTable {
    width: 100%;
  }
}
</style>
